"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.pressureUnits = new localized_strings_1.default({
    en: {
        Atmosphere: {
            AbbreviatedDisplay: 'atm',
            FullDisplay: 'atmospheres'
        },
        Bar: {
            AbbreviatedDisplay: 'bar',
            FullDisplay: 'bars'
        },
        ColumnOfWater: {
            AbbreviatedDisplay: 'col/H20',
            FullDisplay: 'columns of water'
        },
        InchOfMercury: {
            AbbreviatedDisplay: 'in/Hg',
            FullDisplay: 'inches of mercury'
        },
        Kilopascal: {
            AbbreviatedDisplay: 'kPa',
            FullDisplay: 'kilopascals'
        },
        MillimeterOfMercury: {
            AbbreviatedDisplay: 'mmHg',
            FullDisplay: 'millimeters of mercury'
        },
        Pascal: {
            AbbreviatedDisplay: 'pa',
            FullDisplay: 'pascals'
        },
        PoundsPerSquareInch: {
            AbbreviatedDisplay: 'psi',
            FullDisplay: 'pounds per square inch'
        }
    }
}, {
    logsEnabled: false
});
